import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=45b05d14&"
import script from "./InputText.vue?vue&type=script&lang=ts&"
export * from "./InputText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports